import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import Youtube from 'react-youtube';
import movieTrailer from 'movie-trailer';
import {
  AiOutlinePlus, AiOutlineClose, AiOutlineLogout, AiTwotoneHeart, AiOutlineHeart,
} from 'react-icons/ai';
import { TbArrowsShuffle2 } from 'react-icons/tb';
import { BiTrendingUp } from 'react-icons/bi';
import { BsSearch } from 'react-icons/bs';
import { RxCardStack } from 'react-icons/rx';
import { RiHome5Line } from 'react-icons/ri';
import { MdOutlineRadio, MdOutlineCategory } from 'react-icons/md';
import { getUser } from '../../redux/user';
import flixfrenzy from '../../assets/flixfrenzy.webp';
import loader from '../../assets/loader.gif';
import { getMovie } from '../../redux/playMovie';
import Movie from '../Movie/Movie';
import { showMyList } from '../../redux/showMyList';
import './Nav.css';
import { addMyList, removeMyList } from '../../redux/myList';

const Nav = () => {
  const dispatch = useDispatch();

  const [show, handleShow] = useState(false);

  const [active, setActive] = useState(false);

  const [showName, setShowName] = useState(false);

  const [showSearch, setShowSearch] = useState(false);

  const [showSidebar, setShowSidebar] = useState(false);

  const [showCategory, setShowCategory] = useState(false);

  const [popSearch, setPopSearch] = useState(false);

  const [trailerUrl, setTrailerUrl] = useState('');

  const [list, setList] = useState(false);

  const allUsers = useSelector((state) => state.user);

  const playMovieProps = useSelector((state) => state.playMovie);

  const myList = useSelector((state) => state.myList);

  const showMyLists = useSelector((state) => state.showMyList);

  const { showList } = showMyLists;

  const { movie, play } = playMovieProps;

  const navigate = useNavigate();
  useEffect(() => {
    if (allUsers.login !== true || !allUsers.login) {
      navigate('/login');
    // window.location = '/login';
    }
  }, [allUsers.login, navigate]);

  const handleSearch = (e) => {
    e.preventDefault();
    const searchParam = e.target[0].value;
    navigate('/search-result', { state: searchParam });
  };

  const submitPopSearch = (e) => {
    e.preventDefault();
    const searchParam = e.target[0].value;
    navigate('/search-result', { state: searchParam });
    setPopSearch(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        handleShow(true);
      } else handleShow(false);
    });
    // return () => {
    //   window.removeEventListener("scroll");
    // };
  });

  const handleSignOut = () => {
    const user = {
      email: allUsers.email,
      password: allUsers.password,
      login: false,
    };
    dispatch(getUser(user, { type: 'GET_USER' }));
  };

  useEffect(() => {
    movieTrailer(movie?.name || movie?.title || '')
      .then((url) => {
        const urlParams = new URLSearchParams(new URL(url).search);
        setTrailerUrl(urlParams.get('v'));
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.log(error));
  });

  const opts = {
    height: '400px',
    width: '100%',
    position: 'absolute',
    playerVars: {
      autoplay: 1,
    },
  };

  const stopPlay = () => {
    setTrailerUrl('');
    const play = false;
    const playMovieProps = { play };
    dispatch(getMovie(playMovieProps));
    setList(false);
  };

  useEffect(() => {
    setActive(showList);
  }, [showList]);

  const movieList = [
    { title: 'Trending', slug: 'trending-movies', fetch: 'trending' },
    { title: 'Action', slug: 'action', fetch: 'action' },
    { title: 'Comedy', slug: 'comedy', fetch: 'comedy' },
    { title: 'Horror', slug: 'horror', fetch: 'horror' },
    { title: 'Romance', slug: 'romance', fetch: 'romance' },
    { title: 'Music', slug: 'music', fetch: 'music' },
    { title: 'Drama', slug: 'drama', fetch: 'drama' },
    { title: 'Crime', slug: 'crime', fetch: 'crime' },
    { title: 'Adventure', slug: 'adventure', fetch: 'adventure' },
    { title: 'Fantasy', slug: 'fantasy', fetch: 'fantasy' },
    { title: 'Animation', slug: 'animation', fetch: 'animation' },
    { title: 'History', slug: 'history', fetch: 'history' },
    { title: 'Documentaries', slug: 'documentaries', fetch: 'documentary' },
    { title: 'Kids And Family', slug: 'kids-and-family', fetch: 'kidsAndFamily' },
    { title: 'Mystery', slug: 'mystery', fetch: 'mystery' },
    { title: 'Now Playing', slug: 'now-playing', fetch: 'nowPlaying' },
    { title: 'Popular', slug: 'popular', fetch: 'popular' },
    { title: 'Science Fiction', slug: 'science-fiction', fetch: 'scienceFiction' },
    { title: 'Thriller', slug: 'thriller', fetch: 'thriller' },
    { title: 'War', slug: 'war', fetch: 'war' },
    { title: 'Western', slug: 'western', fetch: 'western' },
    { title: 'Upcoming', slug: 'upcoming-movies', fetch: 'upComing' },
    { title: 'Top Rated', slug: 'top-rated-movies', fetch: 'topRated' },
  ];

  const tvList = [
    { title: 'Trending', slug: 'trending-tv-shows', fetch: 'tvTrending' },
    { title: 'Action & Adventure', slug: 'action-and-adventure', fetch: 'tvActionAndAdventure' },
    { title: 'Airing Today', slug: 'tv-shows-airing-today', fetch: 'tvAiringToday' },
    { title: 'Comedy', slug: 'comedy-tv-shows', fetch: 'tvComedy' },
    { title: 'Animation', slug: 'animation-tv-shows', fetch: 'tvAnimation' },
    { title: 'Crime', slug: 'crime-tv-shows', fetch: 'tvCrime' },
    { title: 'News', slug: 'news', fetch: 'tvNews' },
    { title: 'Documentaries', slug: 'tv-documentaries', fetch: 'tvDocumentary' },
    { title: 'Reality', slug: 'reality-tv-shows', fetch: 'tvreality' },
    { title: 'War & Politics', slug: 'war-and-politics', fetch: 'tvWarAndPolitics' },
    { title: 'On Air', slug: 'tv-shows-on-air', fetch: 'tvOnAir' },
    { title: 'Talk', slug: 'talk', fetch: 'tvTalk' },
    { title: 'Top Rated', slug: 'top-rated-tv-shows', fetch: 'tvTopRated' },
    { title: 'Popular', slug: 'popular-tv-shows', fetch: 'tvPopular' },
    { title: 'Sci-Fi & Fantasy', slug: 'sci-fi-and-fantasy', fetch: 'tvSciFiAndFantasy' },
    { title: 'Kids', slug: 'kids-tv-shows', fetch: 'tvKids' },
    { title: 'Family', slug: 'family-tv-shows', fetch: 'tvFamily' },
    { title: 'Soap', slug: 'soap', fetch: 'tvSoap' },
    { title: 'Western', slug: 'western-tv-shows', fetch: 'tvWestern' },
  ];

  const closeShowMyList = () => {
    setActive(false);
    const showMyListState = { showList: false };
    dispatch(showMyList(showMyListState));
  };

  // Remove duplicates
  const ids = myList.allMyList.map(({ id }) => id);
  const filterList = myList.allMyList.filter(({ id }, index) => !ids.includes(id, index + 1));
  // Remove duplicates end

  const selectedMovie = ids.filter((id) => id === playMovieProps.movie?.id);

  useEffect(() => {
    if (selectedMovie.length > 0) {
      setList(true);
    }
  }, [play, selectedMovie.length]);

  const addToList = () => {
    const { movie } = playMovieProps;
    dispatch(addMyList(movie, { type: 'ADD_MYLIST' }));
    setList(true);
  };

  const removeList = () => {
    const { movie } = playMovieProps;
    dispatch(removeMyList(movie, { type: 'REMOVE_MYLIST' }));
    setList(false);
  };

  return (
    <>
      <div className={`header ${show && 'header-black'}`}>
        <img className="header-logo" src={flixfrenzy} alt="flixfrenzy logo" onMouseOver={() => setShowSidebar(!showSidebar)} onFocus={() => setShowSidebar(!showSidebar)} />
        <BsSearch onClick={() => setPopSearch(!popSearch)} className="search-icon header-search-section" />
      </div>
      <div className={(showSidebar ? 'flixfrenzy-popup-sidebar' : ' flixfrenzy-popup-sidebar hide') + (showName ? ' flixfrenzy-popup-sidebar set-width' : '') + (showSearch || showCategory ? ' flixfrenzy-popup-sidebar set-search-width' : '')}>
        <div className="sidebar-container">
          <div className="main-menu-section">
            <div className="search-icon-section menu-section">
              <BsSearch onMouseOver={() => setShowSearch(!showSearch)} className="search-icon" />
            </div>
            <div className="menu-section" onMouseOver={() => setShowName(true)} onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)} onBlur={() => setShowName(false)}>
              <NavLink to="/" className="menu-link">
                <RiHome5Line
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>Home</span>
              </NavLink>
            </div>
            <div className="menu-section" onMouseOver={() => setShowName(true)} onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)} onBlur={() => setShowName(false)}>
              <NavLink to="/surprise-me" className="menu-link">
                <TbArrowsShuffle2
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>Surprise Me</span>
              </NavLink>
            </div>
            <div className="menu-section" onMouseOver={() => setShowName(true)} onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)} onBlur={() => setShowName(false)}>
              <NavLink to="/new-and-popular" className="menu-link">
                <BiTrendingUp
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>New & Popular</span>
              </NavLink>
            </div>
            <div className="menu-section" onMouseOver={() => setShowName(true)} onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)} onBlur={() => setShowName(false)}>
              <NavLink className="menu-link" to="/tv-shows">
                <RxCardStack
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>TV Shows</span>
              </NavLink>
            </div>
            <div className="menu-section" onMouseOver={() => setShowName(true)} onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)} onBlur={() => setShowName(false)}>
              <NavLink className="menu-link" to="/movies">
                <MdOutlineRadio
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>Movies</span>
              </NavLink>
            </div>
            <div className="menu-section" onMouseOver={() => setShowName(true)} onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)} onBlur={() => setShowName(false)}>
              <NavLink className="menu-link" onMouseOver={() => setShowCategory(true)}>
                <MdOutlineCategory
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>Categories</span>
              </NavLink>
            </div>
            <div className="menu-section" onMouseOver={() => setShowName(true)} onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)} onBlur={() => setShowName(false)}>
              <NavLink className="menu-link" onClick={() => setActive(true)}>
                <AiOutlinePlus
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>My List</span>
              </NavLink>
            </div>
            {/* <div className="menu-section notification" onMouseOver={() => setShowName(true)}
            onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)}
            onBlur={() => setShowName(false)}>
              <NavLink className="menu-link" onClick={() => setActive(true)}>
                <MdOutlineNotificationsActive
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>Notifications</span>
              </NavLink>
            </div> */}
            <div className="menu-section logout" onMouseOver={() => setShowName(true)} onFocus={() => setShowName(true)} onMouseOut={() => setShowName(false)} onBlur={() => setShowName(false)}>
              <NavLink className="menu-link" onClick={() => handleSignOut()}>
                <AiOutlineLogout
                  className="main-menu-icon"
                />
                <span className={showName ? 'menu-name' : 'menu-name hide'}>Logout</span>
              </NavLink>
            </div>
          </div>
          <div className={showSearch ? 'search-box-links' : 'search-box-links hide'}>
            <form className="search-form" onSubmit={handleSearch}>
              <input type="text" required className="search-field" />
              {/* eslint-disable-next-line */}
              <button type="submit" className="submit-btn">
                <BsSearch
                  className="main-menu-icon"
                />

              </button>
            </form>
            { movieList.slice(0, 5).map((link) => {
              const movieSlug = link.slug;
              return <Link key={link.slug} className="search-links" to={`/movies/${movieSlug}`} onClick={() => setShowSidebar(false)}>{link.title}</Link>;
            })}

            { tvList.slice(4, 4).map((link) => {
              const tvSlug = link.slug;
              return <Link key={link.slug} className="search-links" to={`/tv/${tvSlug}`} onClick={() => setShowSidebar(false)}>{link.title}</Link>;
            })}
            {/* <Link className="search-links" to="/comedy">Comedies</Link>
            <Link className="search-links" to="/action">Action</Link>
            <Link className="search-links" to="/kids-and-family">Kids & Family</Link>
            <Link className="search-links" to="/romance">Romance</Link>
            <Link className="search-links" to="/horror">Horror</Link>
            <Link className="search-links" to="/documentary">Documentary</Link>
            <Link className="search-links" to="/trending">Trending</Link>
            <Link className="search-links" to="/popular-tv-shows">Popular TV Shows</Link> */}
          </div>

          <div className={showCategory ? 'search-box-links' : 'search-box-links hide'} onMouseOver={() => setShowCategory(true)} onFocus={() => setShowCategory(true)} onMouseOut={() => setShowCategory(false)} onBlur={() => setShowCategory(false)}>
            <div className="movies-categories">
              <Link to="/movies" className="search-links">
                <h2 className="category-header">Movies</h2>
              </Link>
              <div className="movie-categories-list">
                {movieList.map((movie) => {
                  const movieSlug = movie.slug;
                  return <Link key={movie.slug} className="search-links" to={`/movies/${movieSlug}`} onClick={() => setShowSidebar(false)}>{movie.title}</Link>;
                })}

                {/* <Link className="search-links" to="/action">Action</Link>
              <Link className="search-links" to="/comedy">Comedy</Link>
              <Link className="search-links" to="/romance">Romance</Link>
              <Link className="search-links" to="/horror">Horror</Link>
              <Link className="search-links" to="/documentaries">Documentaries</Link>
              <Link className="search-links" to="/now-playing">Now Playing</Link>
              <Link className="search-links" to="/popular">Popular</Link>
              <Link className="search-links" to="/top-rated-movies">Top rated</Link>
              <Link className="search-links" to="/trending">Trending</Link>
              <Link className="search-links" to="/upcoming">Upcoming</Link> */}
              </div>
            </div>
            <div className="tv-categories">
              <Link to="/tv-shows" className="search-links">
                <h2 className="category-header">TV</h2>
              </Link>
              <div className="tv-categories-list">
                {tvList.map((tv) => {
                  const tvSlug = tv.slug;
                  return <Link key={tv.slug} className="search-links" to={`/tv/${tvSlug}`} onClick={() => setShowSidebar(false)}>{tv.title}</Link>;
                })}
                {/* <Link className="search-links" to="/tv-documentaries">Documentaries</Link>
              <Link className="search-links" to="/tv-shows-on-air">Shows On Air</Link>
              <Link className="search-links" to="/popular-tv-shows">Popular TV Shows</Link>
              <Link className="search-links" to="/top-rated-tv-shows">Top Rated TV Shows</Link>
              <Link className="search-links" to="/tv-shows-airing-today">Airing Today</Link>
              <Link className="search-links" to="/tv-shows">All TV Shows</Link> */}
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* <button type="button" className="open-btn" onClick={() => setActive(true)}>
        <TiThMenu className="open-btn-icon" />
      </button> */}
      <div className={active ? 'sidebar sidebar-black visible' : 'sidebar sidebar-black'}>
        <div className={active ? 'sidebar sidebar-red visible' : 'sidebar sidebar-red'}>
          <div className={active ? 'sidebar sidebar-white visible' : 'sidebar sidebar-white'}>
            {/* eslint-disable-next-line */}
            <button type="button" className="close-btn" onClick={() => closeShowMyList()}>
              <AiOutlineClose />
            </button>
            <div className="slide-sidebar-main">
              <div className="main-movie-section">
                {filterList.length === 0 ? (
                  <p className="sidebar-notification">You have no items in your list</p>
                ) : (
                  <Movie fetchUrl={filterList} title="Your Items" />
                )}
              </div>
              <div className="sidebar-menu">
                <Link to="/help" className="sidebar-menu-item">Help</Link>
                <Link to="https://nwachan-theophile.netlify.app" className="sidebar-menu-item">Contact Developer</Link>

                {/* <Link to="/" className="sidebar-menu-item">
                <div className="sub-menu-items">
                  <Link to="/" className="sidebar-menu-item">flixfrenzy Logo</Link>
                  <Link to="/" className="sidebar-menu-item">Work life philosophy</Link>
                  <Link to="/" className="sidebar-menu-item">Illustrations</Link>
                  <Link to="/" className="sidebar-menu-item">Community times</Link>
                  <Link to="/" className="sidebar-menu-item">Wearenterflis</Link>
                </div>
              </Link> */}
                {/* <button type="button" className="sign-up-btn">SIGN UP NOW</button> */}
                <img className="sidebar-logo" src={flixfrenzy} alt="flixfrenzy logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {popSearch ? (
        <div className="popup-container">
          <div className="search-main">
            <div className="popSearch-close">
              <AiOutlineClose className="popup-close-btn" onClick={() => setPopSearch(!popSearch)} />
            </div>
            <div className="popsearch-section">
              <form onSubmit={submitPopSearch} className="search-form">
                <input type="text" required className="popup-search-field" />
                {/* eslint-disable-next-line */}
                <button type="submit" className="popup-submit-btn">
                  <BsSearch
                    className="popup-search-icon"
                  />

                </button>
              </form>
            </div>
          </div>
        </div>
      ) : ''}

      {play ? (
        <div className="popup-container">
          <div className="play-movie-main">
            <div className="popSearch-close">
              <AiOutlineClose className="popup-close-btn" onClick={() => stopPlay()} />
            </div>
            <div className="pop-movie-section">
              {trailerUrl
                ? (
                  <>
                    <Youtube videoId={trailerUrl} opts={opts} />
                    <div className="add-to-list-section">
                      {list ? (
                        <>
                          <AiTwotoneHeart onClick={() => removeList()} className="added-to-list-icon" />
                          <span className="add-to-list-text">Added to favourites</span>
                        </>
                      ) : (
                        <>
                          <AiOutlineHeart onClick={() => addToList()} className="add-to-list-icon" />
                          <span className="add-to-list-text">Add to favourites</span>
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <div className="pop-movie-loader-section">
                    <img src={loader} className="pop-movie-loader" alt="FlixFrenzy" />
                  </div>
                )}
            </div>
          </div>
        </div>
      ) : ''}

    </>
  );
};

export default Nav;
